import requisitantesMenu from "./requisitantes/menu"
import fornecedorMenu from "./fornecedores/menu"
import demandantesMenu from "./demandantes/menu"
import gerentesMenu from "./gerentes/menu"
import finalizacaoMenu from "./finalizacao/menu"
import financeiroMenu from "./financeiro/menu"

export default {
    name: 'Despesas Gerais',
    url: '/despesasgerais',
    icon: 'fa fa-users',
    regras: [
        ...requisitantesMenu.map(r => r.regras),     
        ...fornecedorMenu.map(r => r.regras),
        ...demandantesMenu.map(r => r.regras),
        ...gerentesMenu.map(r => r.regras),
        ...finalizacaoMenu.map(r => r.regras),
        ...financeiroMenu.map(r => r.regras)
    ],
    children: [
        ...requisitantesMenu,
        ...fornecedorMenu,
        ...demandantesMenu,
        ...gerentesMenu,
        ...finalizacaoMenu,
        ...financeiroMenu
    ]
}